"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Circle = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lottieReact = _interopRequireDefault(require("lottie-react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CircleModule = _interopRequireDefault(require("../../styles/components/Circles/Circle.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Circle = exports.Circle = /*#__PURE__*/(0, _react.memo)(props => {
  const {
    isTransition,
    animationData
  } = props;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "".concat(_CircleModule.default.svg, " ").concat(isTransition ? _CircleModule.default.svg_off : _CircleModule.default.svg_on)
  }, /*#__PURE__*/_react.default.createElement(_lottieReact.default, {
    animationData: animationData
  }));
}, function () {
  let prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return !(prev.transition !== next.transition || prev.animationData !== next.animationData);
});
Circle.displayName = 'Circle';
Circle.propTypes = {
  isTransition: _propTypes.default.bool.isRequired,
  animationData: _propTypes.default.shape({}).isRequired
};